import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store';
import { Toast, Dialog } from 'vant';

Vue.use(VueRouter);

export const routes = [
    { path: '/test', name: 'test', component(resolve) { require(['@/views/Test'], resolve) }, meta: { keepAlive: true } },
    { path: "/", name: "/", redirect: '/index' },
    { path: '/index', name: 'index', component(resolve) { require(['@/views/home/index'], resolve) }, meta: { title: '电影/影院', keepAlive: true } },
    { path: "/login", name: "login", component(resolve) { require(['@/views/login'], resolve) }, meta: { title: '登录' } },


    // { path: "/movie", name: "movie", component(resolve) { require(['@/views/movie'], resolve) }, meta: { title: '电影首页' } },
    { path: "/movie-scroll", name: "movie-scroll", component(resolve) { require(['@/views/movie/list'], resolve) }, meta: { title: '全部电影' } },
    { path: "/movie-detail", name: "movie-detail", component(resolve) { require(['@/views/movie/movie-detail'], resolve) }, meta: { title: '电影详情' } },
    { path: "/movie-detail2", name: "movie-detail2", component(resolve) { require(['@/views/movie/movie-detail2'], resolve) }, meta: { title: '电影详情' } },


    { path: "/search", name: "search", component(resolve) { require(['@/views/search'], resolve) }, meta: { title: '搜索' } },
    { path: '/city', name: 'city', component(resolve) { require(['@/views/city'], resolve) }, meta: { title: '城市列表' } },
    { path: '/location-view', name: 'location-view', component(resolve) { require(['@/views/address/location-view'], resolve) }, meta: { title: '查看位置', requireAuth: true } },

    { path: "/cinema", name: "cinema", component(resolve) { require(['@/views/cinema'], resolve) }, meta: { title: '影院列表' } },
    { path: '/movie-session', name: 'movie-session', component(resolve) { require(['@/views/cinema/movie-session'], resolve) }, meta: { title: '电影场次', requireAuth: true } },
    { path: '/cinema-seat', name: 'cinema-seat', component(resolve) { require(['@/views/cinema/cinema-seat'], resolve) }, meta: { title: '影院选座', requireAuth: true } },


    { path: '/order-pay', name: 'order-pay', component(resolve) { require(['@/views/order/order-pay'], resolve) }, meta: { title: '确认订单', requireAuth: true } },
    { path: '/order-pay-done', name: 'order-pay-done', component(resolve) { require(['@/views/order/order-pay-done'], resolve) }, meta: { title: '付款成功', requireAuth: true } },

    { path: "/user", name: "user", component(resolve) { require(['@/views/user'], resolve) }, meta: { title: '我的' } },
    { path: '/user-coupon', name: 'user-coupon', component(resolve) { require(['@/views/user/user-coupon'], resolve) }, meta: { title: '我的卡券', requireAuth: true } },
    { path: '/user-vip', name: 'user-vip', component(resolve) { require(['@/views/user/user-vip'], resolve) }, meta: { title: '贵宾卡', requireAuth: true } },

    { path: '/user-order', name: 'user-order', component(resolve) { require(['@/views/user/user-order'], resolve) }, meta: { title: '我的订单', requireAuth: true } },
    { path: '/user-order-detail', name: 'user-order-detail', component(resolve) { require(['@/views/user/user-order-detail'], resolve) }, meta: { title: '我的订单', requireAuth: true } },
    // { path: '/error/:errorCode', name: 'error', component(resolve) { require(['@/views/error-page'], resolve) }, meta: { title: '请求错误' } },
    { path: '/error', name: 'error', component(resolve) { require(['@/views/error-page'], resolve) }, meta: { title: '请求错误' } },
    { path: '*', name: 'error404', component(resolve) { require(['@/views/error-page/404'], resolve) }, meta: { title: '错误404' } },
    { path: '/checkCard', name: 'checkCard', component(resolve) { require(['@/views/filmOrder/components/checkCard'], resolve) }, meta: { title: '卡券选择', requireAuth: true } },
    { path: '/filmOrder', name: 'Order-index', component(resolve) { require(['@/views/filmOrder/index'], resolve) }, meta: { title: '确认订单', requireAuth: true } },
    { path: '/useCard', name: 'useCard', component(resolve) { require(['@/views/filmOrder/components/useCard.vue'], resolve) }, meta: { title: '使用卡券', requireAuth: true } },
];

const router = new VueRouter({
    mode: "hash",
    // base: process.env.BASE_URL,
    base: '/dumovie',
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //     console.log(savedPosition)
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0 }
    //     }
    // }
});

// router.beforeEach((to, from, next) => {
//     if (to.name != 'index' && to.name.indexOf('error') == -1 && !store.getters.authCode) {
//         Toast('请先登录');
//         next({
//             path: '/error'
//         })
//     } else if (to.name.indexOf('error') == -1 && store.getters.authCode) {
//         if (store.getters.hasGetMemberInfo) {
//             next();
//         } else {
//             store.dispatch('getMemberInfo').then(() => {
//                 next();
//             }).catch(() => {
//                 next();
//             })
//         }
//     } else {
//         next();
//     }
// });

router.beforeEach((to, from, next) => {
    let title = to.meta ? to.meta.title : '';
    // document.title = title;
    document.title = '电影选座';
    store.commit('setTitle', title);

    if (from.query.flag) {
        to.query.flag = from.query.flag
    }
    next();
})

export default router;
